<template>
    <VJoyWrapper no-margin column-gap="1" wrap="nowrap">
        <VJoyIcon name="briefcase" color="neutral-50" size="xsmall" />
        <span class="experience-level-indicator__text" :class="{'experience-level-indicator__text--bold': bold}">{{ experienceLevelValue }}</span>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyIcon, VJoyWrapper} from '@maltjoy/core-vue';
    import type {ExperienceLevel} from '~/types/domain/Profile';

    const props = defineProps<{
        experienceLevel: ExperienceLevel;
        bold?: boolean;
    }>();

    const {t} = useTranslation();

    const experienceLevelValue = computed((): string =>
        props.experienceLevel ? t(`profile.creation.completion.wizard.categorization.experienceLevel.label.v2.${props.experienceLevel}`) : '-',
    );
</script>

<style scoped lang="scss">
    .experience-level-indicator__text {
        white-space: nowrap;
        &--bold {
            font-weight: var(--joy-font-weight-bold);
        }
    }
</style>
